/**
 * @module common/components/form/modal_form_upload
 */
import React, { PropTypes, Component } from 'react';
import Cropper from 'react-cropper';
import classNames from 'classnames';
import FileSelector from 'common/components/file_selector';
import Thumbnail from 'common/components/thumbnail';

/**
 * Modal rendering a file upload form used by portfolio or projects
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class ModalFormUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hideCropper: false,
      hideUploader: false,
      thumbnail: null,
      imageData: null,
      fileBlob: null,
    };

    this.addFile = this.addFile.bind(this);
    this.fileSelected = this.fileSelected.bind(this);
    this.cropImage = this.cropImage.bind(this);
    this.hideCropper = this.hideCropper.bind(this);
  }

  cropImage(event) {
    event.preventDefault();
    if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
      return;
    }

    const thumbnail = this.cropper.getCroppedCanvas().toDataURL();
    this.props.onCrop(thumbnail, thumbnail);
    this.fileSelected(thumbnail, true);
  }

  addFile() {
    this.refs.selector.dropzone.open();
  }

  hideCropper() {
    this.setState({
      hideCropper: true,
      hideUploader: false,
      imageData: null,
      fileBlob: null,
      thumbnail: null,
    });
  }

  fileSelected(file, thumbnail) {
    const cropped = thumbnail === undefined ? false : thumbnail;

    if (!cropped) {
      const urlCreator = window.URL || window.webkitURL;
      const imageUrl = urlCreator.createObjectURL(file);
      const changes = {
        fileBlob: file,
        imageData: imageUrl,
        uploaded: true,
        hideCropper: false,
        hideUploader: true,
      };

      if (this.state.thumbnail) {
        changes.thumbnail = null;
      }
      this.setState(changes);
    } else {
      this.setState({
        thumbnail: file,
        hideCropper: false,
        hideUploader: true,
      });
    }
  }

  render() {
    return (
      <div className="file-upload-form">
        <div className="row selector-header">
          { this.props.header }
        </div>
        <div className="row">
          { this.state.thumbnail ?
            <div className="small-16 column thumbnail-preview">
              <Thumbnail image={this.state.thumbnail} className="thumbnail flex" />
            </div>
            : null
          }
          { (this.state.imageData && !this.state.thumbnail && !this.state.hideCropper) ?
            <div className="small-16 column form-upload-box">
              <Cropper
                ref={(c) => { this.cropper = c; }}
                src={this.state.imageData}
                style={{ height: '100%', width: '100%' }}
                aspectRatio={1 / 1}
                guides={false}
                crop={this._crop}
              />
              <button
                type="button"
                className="btn btn-primary file-done"
                onClick={this.cropImage}
              >Done</button>
            </div>
            : null
          }
          <div className={classNames('small-16 column', {
            hidden: this.state.imageData && this.state.hideUploader })}
          >
            <div className="form-upload-box">
              <FileSelector
                ref="selector"
                minImageWidth={300}
                minImageHeight={300}
                onInvalidOrRejected={this.hideCropper}
                onValidFileSelected={this.fileSelected}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {node} header - markup to render in the form content header
 * @property {func} onCrop - function called when new image is cropped
 */
ModalFormUpload.propTypes = {
  header: PropTypes.node,
  onCrop: PropTypes.func,
};



// WEBPACK FOOTER //
// ./common/components/form/modal_form_upload.jsx